import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'caso/casoslocation',
    ...crudState(),
    seleccion: []
  }),
  getters: {
    ...crudGetters,
    seleccion: state => state.seleccion
  },
  mutations: {
    ...crudMutations,
    setSeleccion (state, value) {
      state.seleccion = value
    }
  },
  actions: {
    ...crudActions,
    seleccionarCasos ({ commit }, data) {
      commit('setSeleccion', data)
    }
  }
}
